"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertShape;
var _assertObject = _interopRequireDefault(require("./assertObject"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function assertShape(value) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  if (keys.length > 0) {
    (0, _assertObject["default"])(value, label);
    var objKeys = Object.keys(value);
    if (keys.length !== objKeys.length || JSON.stringify(keys) !== JSON.stringify(objKeys)) {
      throw new Error("".concat(label, "'s 'keys' does not matched with keys: ").concat(keys.join(', ')));
    }
  } else {
    throw new Error('assertShape\'s \'keys\' argument is required');
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/assertShape.js
// module id = 1880
// module chunks = 0